import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Devis from "./pages/Devis";
import Contact from "./pages/Contact";
import Realisations from "./pages/Realisations";
import ServiceDetail from "./pages/ServiceDetail";
import Splash from "./components/Splash";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Splash />
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/chapes/:slug" element={<ServiceDetail groupKey="chapes" />} />
              <Route path="/isolations/:slug" element={<ServiceDetail groupKey="isolations" />} />
              <Route path="/solutions/:slug" element={<ServiceDetail groupKey="solutions" />} />
              <Route path="/realisations" element={<Realisations />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/devis" element={<Devis />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Layout>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
